<svg [class]="'ui-icon-svg size-' + size">
  <use
    [attr.xlink:href]="'assets/icons.svg#' + iconName"
    [attr.href]="'assets/icons.svg#' + iconName"
  ></use>
</svg>
